<template>
  <div>
    <el-card>
      <div class="head-group">
        <div class="left-part">
          <div class="rowpart">
            <el-date-picker
              style="width: 120px"
              v-model="year"
              type="year"
              placeholder="选择年"
              format="YYYY"
              value-format="YYYY"
            >
            </el-date-picker>
          </div>
          <SeasonSelect class="rowpart" v-model="this.season"></SeasonSelect>
          <el-icon-search></el-icon-search>
          <el-input
            v-model="searchKeyWord"
            placeholder="搜索姓名或单位"
            style="width: 200px; margin-right: 20px"
          ></el-input>
        </div>

        <div class="right-part">
          <el-button type="primary" @click="handleAddBtn">添加</el-button>
        </div>
      </div>

      <!-- 表格 -->
      <el-table
        :data="
          filteredData.slice(
            (currentPage - 1) * pagesize,
            currentPage * pagesize
          )
        "
        border
        style="width: 100%"
        height="600"
        class="diffrow"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        :default-sort="{ prop: 'id' }"
      >
        <el-table-column type="index" width="50" fixed> </el-table-column>
        <template v-for="column in absenceTable" :key="column.label">
          <el-table-column
            :prop="column.prop"
            :label="column.label"
            width="180"
            :formatter="formatter"
          >
          </el-table-column>
        </template>
        <el-table-column label="操作" width="160" fixed="right">
          <template #default="scope">
            <el-button type="text" @click="handleEdit(scope.$index, scope.row)"
              >查看</el-button
            >
            <el-popconfirm
              title="确认删除?"
              @confirm="deleteRecord(scope.$index, scope.row)"
              confirm-button-text="是"
              cancel-button-text="否"
            >
              <template #reference>
                <el-button type="text">删除</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-block">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="filteredData.length"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>

      <!-- 添加考勤异常记录模态框 -->
      <el-dialog
        v-model="showable.absenceForm"
        title="添加考勤异常记录"
        width="40%"
      >
        <el-form label-width="120px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="人员姓名">
                <EmployeeSelectV2
                  :depIdArr="[this.departmentId]"
                  :type="select"
                  v-model="absenceForm.userId"
                ></EmployeeSelectV2>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="缺勤类型">
                <AbsenceSelect v-model="absenceForm.type"></AbsenceSelect>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="开始时间">
                <el-date-picker
                  v-model="absenceForm.beginDate"
                  type="date"
                  placeholder="选择日期"
                  :locale="zhCn"
                  style="width: 100%"
                  value-format="YYYY-MM-DD"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间">
                <el-date-picker
                  v-model="absenceForm.endDate"
                  type="date"
                  placeholder="选择日期"
                  :locale="zhCn"
                  style="width: 100%"
                  value-format="YYYY-MM-DD"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="时长(天)">
                <el-input v-model="absenceForm.duration"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="扣分值">
                <el-input v-model="absenceForm.minusScore"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="事由">
                <el-input
                  type="textarea"
                  v-model="absenceForm.reason"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input
                  type="textarea"
                  v-model="absenceForm.remarks"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="botton-btn">
            <el-button
              type="primary"
              @click="addRecord"
              :disabled="disable.addItemBtn"
              >确认添加</el-button
            >
            <el-button type="default" @click="doCancel">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import AttendanceManage from "../api/AttendanceManage";
export default AttendanceManage;
</script>

<style scoped lang="scss">
.head-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.rowpart {
  margin-right: 10px;
  width: 120px;
}

.left-part {
  display: flex;
  align-items: center;
}

.right-part {
  display: flex;
  align-items: center;
}

.diffrow {
  margin-top: 20px;
}

.pagination-block {
  margin-top: 30px;
}

.botton-btn {
  text-align: end;
}
</style>